import React, { useState, useEffect, useRef } from 'react'
import useFetch from '../hooks/useFetch'
import { Link, useHistory } from 'react-router-dom'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Container, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ReceiptIcon from '@mui/icons-material/Receipt';
import EditNoteIcon from '@mui/icons-material/EditNote';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useMsal } from "@azure/msal-react";
import TextField from '@mui/material/TextField';
import './homepage.css'
import home from '../assets/home.svg'
import ProjectItem from '../components/ProjectItem';
import SettingsIcon from '@mui/icons-material/Settings';
import UserPopup from './UserPopup';
import PopupExpense from '../components/popupExpense/PopupExpense';
import BulkImportDialog from '../components/BulkImportDialog/BulkImportDialog';
import add_contract from '../assets/add_contract.svg'

export default function Homepage() {

  const [filterValue, setFilterValue] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [openUserPopup, setOpenUserPopup] = useState(false);
  const [usersData, setUsersData] = useState({});
  const [openAddExpense, setOpenAddExpense] = useState(false);
  const [expenseInitialMode, setExpenseInitialMode] = useState('receipt');
  const [openBulkImport, setOpenBulkImport] = useState(false);
  const [addMenuAnchor, setAddMenuAnchor] = useState(null);

  const fileInputRef = useRef(null);

  const { instance, accounts } = useMsal();
  const name = accounts[0].name;
  const email = accounts[0].username;
  const history = useHistory();
  const { loading, error, data } = useFetch('/api-dev/expenses/GetProject', name == "Seddik Houimli" ? "Thomas Tanghe" : name, 
  email == "seddik.houimli@nova.space" ? "thomas.tanghe@nova.space" : email)
  const {projects, admins, candidates, finance, entities, createExpense, currentUser} = data || {}
  useEffect(() => {
    setFilteredData(projects)
  }, [projects])

  const handleClick = (id) => {
    history.push({
      pathname: '/task/' + id,
    })
  }

  if (loading) return (
    <div className='spinner'>
      <Box sx={{ display: 'flex' }} style={{ margin: '40px', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    </div>
  );

  if (error) return <p>Error :(</p>;

  function compare(a, b) {
    if (a.ProjectName < b.ProjectName) return -1;
    if (a.ProjectName > b.ProjectName) return 1;
    return 0;
  }

  projects.sort(compare);

  // 👇 Triggered when user clicks "Add Expense"
  const handleAddExpenseClick = (event) => {
    setAddMenuAnchor(event.currentTarget);
  };

  const handleAddMenuClose = () => {
    setAddMenuAnchor(null);
  };

  const handleFromReceipt = () => {
    handleAddMenuClose();
    setExpenseInitialMode('receipt');
    setOpenAddExpense(true);
  };

  const handleEnterManually = () => {
    handleAddMenuClose();
    setExpenseInitialMode('manual');
    setOpenAddExpense(true);
  };

  const handleImportFromExcel = () => {
    handleAddMenuClose();
    setOpenBulkImport(true);
  };

  // 👇 Triggered when user selects a file
  const handleFileSelected = (event) => {
    setOpenAddExpense(true);
  };

  return (
    <div className='page-layout'>
      <UserPopup openPopup={openUserPopup} setOpenPopup={setOpenUserPopup} />
      {<PopupExpense
        setOpenPopup={setOpenAddExpense}
        candidates={candidates}
        openPopup={openAddExpense}
        entities={entities}
        initialEntryMode={expenseInitialMode}
      />}
      <BulkImportDialog
        open={openBulkImport}
        onClose={() => setOpenBulkImport(false)}
        candidates={candidates}
        entities={entities}
      />

      {/* Hidden file input */}
      <input
        type="file"
        accept="image/*,.pdf"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelected}
      />

      <div className='header'>
        <div className='navigation'>
          <Link to="/" className='link-navigation'>
            <p>
              <img src={home} alt="home" className="home" />
              &nbsp; Projects
            </p>
          </Link>
        </div>

        <div className='search-boxs'>
          {
            // StaffTeam should contain 'Senior Finance Staff' 
          }
          {currentUser.find(user => user.StaffTeam.includes('Senior Finance Staff')) && (
            <div onClick={() => setOpenUserPopup(true)}>
              <SettingsIcon className='icon-gear' onClick={() => setOpenUserPopup(true)} />
            </div>
          )}

          {createExpense.find(fin => fin.Name === name) && (
            <>
              <div
                className="summary-button-single-tool"
                style={{ marginTop: '5px' }}
                onClick={handleAddExpenseClick}
              >
                <div className="summary-button-label-tool">
                  <img src={add_contract} alt="add-expense" className="add" />
                  &nbsp;Add Expense
                </div>
              </div>
              <Menu
                anchorEl={addMenuAnchor}
                open={Boolean(addMenuAnchor)}
                onClose={handleAddMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              >
                <MenuItem onClick={handleFromReceipt} selected>
                  <ListItemIcon><ReceiptIcon fontSize="small" /></ListItemIcon>
                  From receipt
                </MenuItem>
                <MenuItem onClick={handleEnterManually}>
                  <ListItemIcon><EditNoteIcon fontSize="small" /></ListItemIcon>
                  Enter manually
                </MenuItem>
                {/* <MenuItem onClick={handleImportFromExcel}>
                  <ListItemIcon><UploadFileIcon fontSize="small" /></ListItemIcon>
                  Import from Excel file
                </MenuItem> */}
              </Menu>
            </>
          )}

          <div className='search-box'>
            <TextField
              style={{ borderRadius: '5px', border: 'none' }}
              id="search"
              type="search"
              label="Search a project"
              value={filterValue}
              size="small"
              onChange={(event) => {
                setFilterValue(event.target.value)
                setFilteredData(
                  projects.filter(project =>
                    project.ProjectName.toLowerCase().includes(event.target.value.toLowerCase())
                  )
                )
              }}
              sx={{ width: 380 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>
      </div>

      <div className='project-list'>
        {filteredData.map(project => (
          <div key={project.ProjectID} style={{ marginTop: '7px' }}>
            <ProjectItem project={project} handleClick={handleClick} />
          </div>
        ))}
      </div>
    </div>
  )
}

        {/*filteredData.map(review => (
        <div key={review.ProjectID} style={{ 'marginTop': '7px' }}>
          <Box sx={{ flexGrow: 1 }} >
            <AppBar position="static" style={{background:'white',borderRadius:'5px'}}>
              <Toolbar onClick={() => handleClick(review.ProjectID)} style={{ cursor: 'pointer',background:'white', height:'50px',borderRadius:'5px' }}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 2 }}>
                  <div style={{ display: 'flex' }}>
                    {review.ProjectName}
                    {review.nb_errors > 0 ?
                      <div style={{ borderRadius: '50%', backgroundColor: 'red', width: '29px', marginLeft: '5px', height: '29px', textAlign: 'center' }}>
                        {review.nb_errors}
                      </div> : <></>}

                  </div>
                </Typography>

                <Button color="inherit" >

                  <ArrowForwardIosIcon />

                </Button>
              </Toolbar>
            </AppBar>
          </Box>
        </div>
                    ))*/}